let loadingPromise = null;

export function loadGoogleMaps() {
  if (window.google && window.google.maps) return Promise.resolve(window.google.maps);
  if (loadingPromise) return loadingPromise;
  loadingPromise = new Promise((resolve, reject) => {
    const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    if (!key) { reject(new Error("Chiave Google Maps non configurata")); return; }
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&language=it&region=IT`;
    script.async = true;
    script.onload = () => resolve(window.google.maps);
    script.onerror = () => reject(new Error("Impossibile caricare Google Maps"));
    document.head.appendChild(script);
  });
  return loadingPromise;
}

export const COMPANY_HQ_ADDRESS = "Via Colombara 7, 20079 Pedriano, San Giuliano Milanese MI, Italia";
